import { trackEvent } from '@99designs/tracking';
import { DesignerSource } from '@99designs/graph-utils/types';

export enum Events {
    BRIEF_VIEWED = 'Project brief viewed',
    BRIEF_RESUMED = 'Project brief resumed',
    CLICKED_NEXT_BUTTON = 'Project brief next button clicked',
    DESIGNER_ADDED = 'Project brief designer added',
    DESIGNER_REMOVED = 'Project brief designer removed',
    DESIGNER_VIEWED = 'Project brief designer viewed',
    CLICKED_EDIT_BUTTON = 'Project brief edit button clicked',
    BRIEF_ENTRY_VIEWED = 'Project brief entry page viewed',
    PROJECT_INVOICE_PAYMENT_SUCCESSFUL = 'Project invoice payment successful',
    BRIEF_MODAL_VIEWED = 'Project Brief Modal Viewed',
}

type BriefEventProps = {
    id: string;
};

type ViewedProjectBriefEventProps = BriefEventProps & {
    page:
        | 'AboutYou'
        | 'Details'
        | 'TimeAndBudget'
        | 'Summary'
        | 'InviteDesigners'
        | 'Invoice'
        | 'AboutYourCampaign';
};

type ViewedSquarespaceBriefEventProps = BriefEventProps & {
    page: 'SquarespaceDesigners' | 'SquarespaceDirect';
    initial_email_address: string;
};

type BriefTransitionViewedBriefEventProps = BriefEventProps & {
    page: 'ExternalBriefTransition';
};

type BriefModalViewedBriefEventProps = BriefEventProps & {
    modal: 'DesignerConfirmation' | 'Auth' | 'DesignerProfile';
    schema_id: string;
};

type ViewedBriefEventProps =
    | ViewedProjectBriefEventProps
    | ViewedSquarespaceBriefEventProps
    | BriefTransitionViewedBriefEventProps
    | BriefModalViewedBriefEventProps;

type EditBriefEventProps = BriefEventProps & {
    page: 'AboutYou' | 'Details' | 'TimeAndBudget' | 'AboutYourCampaign';
};

type BriefEntryEventProps = {
    user_id: number;
};
type DesignerEventProps = BriefEventProps & {
    relevant_ranking?: number;
    designer_level?: string;
    designer_name?: string;
    designer_id: number;
    designer_source?: DesignerSource;
};

export function trackEditBriefEvent(params: EditBriefEventProps): void {
    trackEvent(Events.CLICKED_EDIT_BUTTON, params);
}

export function trackViewedBriefEvent(params: ViewedBriefEventProps): void {
    trackEvent(Events.BRIEF_VIEWED, params);
}

export function trackResumedBriefEvent(params: BriefEventProps): void {
    trackEvent(Events.BRIEF_RESUMED, params);
}

export function trackClickedNextButtonEvent(params: BriefEventProps): void {
    trackEvent(Events.CLICKED_NEXT_BUTTON, params);
}

export function trackAddedDesignerEvent(params: DesignerEventProps) {
    trackEvent(Events.DESIGNER_ADDED, params);
}

export function trackRemovedDesignerEvent(params: DesignerEventProps) {
    trackEvent(Events.DESIGNER_REMOVED, params);
}

export function trackViewedDesignerEvent(params: DesignerEventProps) {
    trackEvent(Events.DESIGNER_VIEWED, params);
}

export function trackBriefEntryViewedEvent(params: BriefEntryEventProps): void {
    trackEvent(Events.BRIEF_ENTRY_VIEWED, params);
}

export function trackBriefModalViewedEvent(params: ViewedBriefEventProps) {
    trackEvent(Events.BRIEF_MODAL_VIEWED, params);
}
